import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { IsDeleteDialogComponent } from './is-delete-dialog.component';
import { IsDeleteDialogService } from './is-delete-dialog.service';

@NgModule({
    declarations: [IsDeleteDialogComponent],
    imports: [
        CommonModule,
        TranslateModule,
        MatDialogModule,
        MatButtonModule,
        MatFormFieldModule,
        MatDividerModule,
        MatInputModule,
        MatSelectModule,
        NgxDropzoneModule,
        MatIconModule,
        ReactiveFormsModule,
        FormsModule,
        TranslateModule
    ],
    providers: [IsDeleteDialogService],
    exports: [IsDeleteDialogComponent]
})
export class IsDeleteDialogModule {}
